
import React from 'react'

import './styles/Video.scss';
import PlayArrowImg from '../../images/icons/play_arrow_white.svg';

const VideoThumb = (props) => {

    return <div className={props.class || 'video-card'}>
        <div className="video-media" style={{position: 'relative'}}>
          <img alt="Youtube pic" src={`https://img.youtube.com/vi/${props.video.code}/0.jpg`} width="100%" />
          <div onClick={() => {
              props.click(props.video)
            }
          } className="play-cover" >
            <img alt="Play/Pause" src={PlayArrowImg} />
          </div>
        </div>
        <div className="card-content fill" style={{
        }}>
          {props.showName && <label className="md-caption" >{props.video.name}</label>}
          {props.showDescription && <p className="small description">{props.video.description}</p>}
        </div>
          { props.children }

      </div>
}

VideoThumb.defaultProps = {
  click: ()=>{},
  video: {},
  showDescription: true,
  showName: true
}

export default VideoThumb;



// WEBPACK FOOTER //
// ./src/components/video/VideoThumb.jsx